Bingo.FilterState = {};

Bingo.FilterState.init = function () {
    $('.js-statusFilter__dropdown').on('shown.bs.dropdown', () => {
        $('body').addClass('filter-state-active');
        $('.js-statusFilter__backdrop').fadeIn();
    });
    $('.js-statusFilter__dropdown').on('hidden.bs.dropdown', () => {
        $('body').removeClass('filter-state-active');
        $('.js-statusFilter__backdrop').fadeOut();
    });
};
